





















import { Component, Vue, Prop } from 'vue-property-decorator';
import DefaultMailEditInput from '@/components/organisms/default/mail_edit/DefaultMailEditInput.vue';
import PRS0000001MailEditInput from '@/components/organisms/PRS0000001/mail_edit/PRS0000001MailEditInput.vue';
import { VueHelper } from '@/helpers/vue';
import { AllowSettings, LoginBackCode } from '@/types/converter/convert';
import { GetCustomerEditRequest } from '@/types/api/types-api';
import { ErrorHelper } from '@/helpers/error';
import PRS0000001SubFooter from '@/components/organisms/PRS0000001/footer/PRS0000001SubFooter.vue';

@Component({
    components: {
        DefaultMailEditInput,
        PRS0000001MailEditInput,
        PRS0000001SubFooter
    },
})
export default class MailEditInput extends Vue {

    private isLoading: boolean = true
    private response: any;
    private isLogin: boolean = false
    @Prop() private provisionShopCode! : string;

    async created () {
        //this.provisionShopCode = VueHelper.getParameter(this, 'provision_shop_code')
        if (!AllowSettings.isUseMailEdit(this.provisionShopCode)) {
            VueHelper.move(this, '/404')
        }
        const request: GetCustomerEditRequest = new GetCustomerEditRequest(this.provisionShopCode)
        VueHelper.lock()
        const response: any = await this.$api.getCustomerEdit(request);
        if (ErrorHelper.apiErrorHandler(
            response,
            this,
            [],
            LoginBackCode.MAIL_EDIT.code)) {
            this.isLogin = true
        }
        VueHelper.unlock()
        this.response = response.data
        this.isLoading = false
    }

    linkLogin() {
        VueHelper.transitionByLocation(
            this,
            { path: '/login', query: { provision_shop_code: this.provisionShopCode, back_url_code: LoginBackCode.MAIL_EDIT.code }}
        )
    }

}
